import { render, staticRenderFns } from "./AppButtonMove.vue?vue&type=template&id=700cdcf8"
import script from "./AppButtonMove.vue?vue&type=script&lang=js"
export * from "./AppButtonMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports